const body = document.body
const headerGroup = body.querySelector('#header-group')
const pageHeader = headerGroup.querySelector('#page-header')
const burger = pageHeader.querySelector('.js-burger')
const mobileMenu = pageHeader.querySelector('.js-mobile-menu')
const cartButton = pageHeader.querySelector('.js-cart-button')

burger.addEventListener('click', () => {
  const isActive = mobileMenu.dataset.active === 'true'
  const willActive = !isActive

  burger.ariaLabel = willActive ? 'close' : 'open'
  burger.dataset.active = willActive

  mobileMenu.dataset.active = willActive

  body.classList.toggle('tw:overflow-hidden', willActive)
})

let prevScrollY = 0
window.addEventListener('scroll', () => {
  const { scrollY } = window

  pageHeader.dataset.background = scrollY > 0

  const scrollDirection = scrollY > prevScrollY ? 'down' : 'up'
  prevScrollY = scrollY 

  if (scrollY < 200) {
    headerGroup.dataset.hidden = false
    return
  }

  headerGroup.dataset.hidden = scrollDirection === 'down'
}, { passive: true })

const refreshCartCount = () => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const countElements = document.querySelectorAll('#cart-count');
      countElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    })
    .catch(error => console.error(error));
}

document.addEventListener('cart:updated', refreshCartCount);

refreshCartCount()

async function updateCartCountUI() {
  try {
    // Fetch the current cart data from Shopify's API endpoint
    const response = await fetch('/cart.js');
    const cart = await response.json();
    // Get the cart item count from the response
    const itemCount = cart.item_count;

    // Find your header cart count element and update its content
    // You will need to replace '.your-cart-count-selector' with the actual class/ID from your theme
    const cartCountElement = document.querySelector('#cart-count'); 
    if (cartCountElement) {
      cartCountElement.innerHTML = itemCount;
    }
  } catch (error) {
    console.error("Error fetching cart details:", error);
  }
}

// Wrap the native fetch function to intercept requests
(function() {
  if (!window.fetch || typeof window.fetch !== "function") return;

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];

    // Call the original fetch function
    const response = originalFetch.apply(this, args);

    // Check if the request URL is related to the cart
    if (url.includes('/cart/add.js') || url.includes('/cart/change.js')) {
        response.then(res => {
            // Once the cart update is successful, update the UI
            updateCartCountUI();
        }).catch(error => {
            console.error("Error in wrapped fetch:", error);
        });
    }

    return response;
  };
})();
